import React from 'react';

const About = () =>
	<section className='about'>
		<div className='masters'>
			<div className='niko anime'>
				<div className='photo'></div>
				<div className='des'>
					<h4>NIKO</h4>
					<h2>tattoo master</h2>
					<article>
						Стаж не больше 1 года. Испортил и так устрашающую спину своей девушке.
						Лежал в дурке. Не любит делиться вейпом. Любит свою маму. Не любит брата.
						Не любит делиться вейпом с братом. Спит с открытым ртом
					</article>
				</div>
			</div>
			<div className='jester anime'>
				<div className='photo'></div>
				<div className='des'>
					<h4>JESTER</h4>
					<h2>tattoo master</h2>
					<article>
						Когда-то ударился головой. Было больно. Сразу решил делать тату.
						Делает тату
					</article>
				</div>
			</div>
		</div>
		<div className='studio anime'>
			<div className='studio-0'></div>
			<div className='studio-1 txt'>
				Первые впечатления от студии играет одну из ключевых ролей для настроя
				клиента. Мы пытались максимально уютно обставить студию, чтобы боль
				от иглы отходила на задний план благодаря успокающему интеръеру
			</div>
			<div className='studio-2'></div>
			<div className='studio-3'></div>
			<div className='studio-4 txt'>
				Благодаря техническому образованию мы сами производим и усовершенствуем
				нашу апаратуру
			</div>
			<div className='studio-5'></div>
			<div className='studio-6 txt'>у нас бесконечный запас медикаментов,
				даже на случай ядерной войны
			</div>
			<div className='studio-7'></div>
			<div className='studio-8'></div>
			<div className='studio-9 txt'>у нас есть кофе</div>
			<div className='studio-10'></div>
			<div className='studio-11 txt'>ну и чай..</div>
			<div className='studio-12'></div>
		</div>
	</section>

export default About;